import React, { FC } from 'react';
import { useElementSize, useWindowSize } from 'usehooks-ts';

import styles from './roomstay-blog-customer-case-hero-2.module.scss';
import ClippedBox, { POSITION } from '../roomstay-blog-image-block/clipped-box';
import classNames from 'classnames';
import { LazyLoadImage } from '../lazy-load-image';

export interface CustomerCaseHeroProps {
    tags?: {
        tag: string;
    }[];
    subTitle?: string;
    title?: string;
    description?: string;
    graphic?: string;
    backgroundImage?: string;
}

const RoomStayCustomerCaseHero2: FC<CustomerCaseHeroProps> = (props) => {
    const { tags = [], subTitle, title, description, graphic, backgroundImage } = props;

    const { width: windowWidth } = useWindowSize();
    const [containerRef] = useElementSize();
    const isTablet = windowWidth <= 991;

    return (
        <div ref={containerRef} className={styles.container}>
            {' '}
            <div className={styles.background}
                style={{
                    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: '50%',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <div 
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#1C1624',
                        opacity: 0.7,
                        zIndex: 1,
                    }}
                />
                <ClippedBox
                    configs={[]}
                    customPolygon={isTablet ? "0% 0%, 0% 100%, 393% 0%, 0% 0%" : "0% 0%, 0% 100%, 170% 0%, 0% 0%"}
                    className={classNames(styles.background, styles.backgroundClippedBottom)}
                    style={{
                        backgroundColor: '#fff',
                        maxHeight: isTablet ? 189 : 170,
                        transform: 'rotate(180deg)',
                    }}
                />
            </div>
            <div className={styles.wrapperContent}>
                <div className={styles.contentBoxLeft}>
                    <div className={styles.wrapperText}>
                        <div className={styles.tags}>
                            {tags?.map((item, index) => (
                                <span key={index}>{item.tag}</span>
                            ))}
                        </div>
                        <div className={styles.subTitle} dangerouslySetInnerHTML={{ __html: subTitle || '' }}></div>
                        <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></h1>
                        <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }}></div>{' '}
                    </div>
                </div>
                <div className={styles.contentBoxRight}>
                    <div className={styles.img}>{graphic && <LazyLoadImage imageUrl={graphic} alt="" objectFit="cover" />}</div>
                </div>
            </div>
        </div>
    );
};

export default RoomStayCustomerCaseHero2;
